import { render } from "./SkeletonCardPolicy.vue?vue&type=template&id=3f3e62e6&scoped=true"
import script from "./SkeletonCardPolicy.vue?vue&type=script&lang=js"
export * from "./SkeletonCardPolicy.vue?vue&type=script&lang=js"

import "./SkeletonCardPolicy.vue?vue&type=style&index=0&id=3f3e62e6&lang=scss&scoped=true"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-external-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f3e62e6"]])

export default __exports__